// ─────────────────────────────────────────────────────────────────────────
// TarjetaSemana.js — fila compacta de uno de "los 7 de esta semana".
//
// Título, siguiente acción en una línea y plazo. Acción principal "Cerrar" y un menú
// de tres puntos con congelar, nota, editar y sacar de la semana. El panel de cierre,
// nota o edición lo arma Tablero (depende de su estado `panel`) y llega listo en `panel`.
// ─────────────────────────────────────────────────────────────────────────
import React, { useState } from "react";
import { AREAS, C, boton, Meta } from "./componentes";

const itemMenu = {
  display: "block",
  width: "100%",
  textAlign: "left",
  minHeight: 44,
  padding: "10px 14px",
  background: "transparent",
  border: "none",
  color: C.texto,
  fontSize: 15,
  cursor: "pointer",
};

const TarjetaSemana = ({ f, hoy, panel, onAbrirPanel, onCongelar, onSacar }) => {
  const [ver, setVer] = useState(false);
  const [menu, setMenu] = useState(false);
  const nota = (f.notas || []).length > 0 ? f.notas[f.notas.length - 1].texto : "";
  const elegir = fn => () => {
    setMenu(false);
    fn();
  };

  return (
    <div role="group" aria-label={f.titulo} style={{ position: "relative", background: C.caja, border: `1px solid ${C.borde}`, borderRadius: 12, padding: "10px 12px", marginBottom: 8 }}>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
        <div role="button" aria-expanded={ver} onClick={() => setVer(v => !v)} style={{ flex: 1, minWidth: 0, cursor: "pointer" }}>
          <div style={{ fontSize: 11, color: C.azul, textTransform: "uppercase", letterSpacing: ".06em" }}>{AREAS[f.area] || f.area}</div>
          <div style={{ fontSize: 16, fontWeight: 600, lineHeight: 1.3 }}>{f.titulo}</div>
          {f.siguienteAccion && (
            <div className={ver ? undefined : "tab-una-linea"} style={{ fontSize: 14, color: ver ? C.texto : C.suave, marginTop: 3, lineHeight: 1.4 }}>
              {f.siguienteAccion}
            </div>
          )}
          <Meta f={f} hoy={hoy} />
          {ver && nota && <div style={{ fontSize: 13, color: C.suave, marginTop: 6 }}>Última nota: {nota}</div>}
        </div>
        <div style={{ display: "flex", gap: 6, flex: "0 0 auto" }}>
          <button style={boton(C.verde)} onClick={() => onAbrirPanel(f, "cerrar")}>Cerrar</button>
          <button
            aria-label="Más acciones"
            aria-haspopup="menu"
            aria-expanded={menu}
            style={{ ...boton(), padding: "8px 12px", fontSize: 18, lineHeight: 1 }}
            onClick={() => setMenu(m => !m)}
          >
            ⋯
          </button>
        </div>
      </div>

      {menu && (
        <>
          {/* Velo transparente: tocar fuera cierra el menú. */}
          <div onClick={() => setMenu(false)} style={{ position: "fixed", inset: 0, zIndex: 20 }} />
          <div
            role="menu"
            style={{ position: "absolute", right: 10, top: 58, zIndex: 21, minWidth: 220, background: C.toast, border: `1px solid ${C.borde}`, borderRadius: 10, boxShadow: C.sombra, overflow: "hidden" }}
          >
            <button role="menuitem" style={itemMenu} onClick={elegir(onCongelar)}>Congelar</button>
            <button role="menuitem" style={itemMenu} onClick={elegir(() => onAbrirPanel(f, "nota"))}>Nota</button>
            <button role="menuitem" style={itemMenu} onClick={elegir(() => onAbrirPanel(f, "editar"))}>Editar siguiente acción</button>
            <button role="menuitem" style={itemMenu} onClick={elegir(onSacar)}>Sacar de la semana</button>
          </div>
        </>
      )}

      {panel}
    </div>
  );
};

export default TarjetaSemana;
